import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicLayout from '../views/basicLayout/index'
import checkRoot from '../views/checkRoot/index.vue'

Vue.use(VueRouter)

// 在vue项目中，如果使用$router.push跳转到一个相同的路由报错 解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'BasicLayout',
    redirect: '/taskHome',
    component: BasicLayout,
    children: [
      {
        path: '/checkRoot',
        name: 'checkRoot',
        meta: {
          title: '登录'
        },
        component: checkRoot
      },
      {
        path: '/taskHome',
        name: 'TaskHome',
        meta: {
          title: '任务大厅'
        },
        component: () => import('../views/taskHome/index.vue')
      }, {
        path: '/mine',
        name: 'Mine',
        meta: {
          title: '我的'
        },
        component: () => import('../views/mine/index.vue')
      }, {
        path: '/taskHome/taskInfo',
        name: 'TaskInfo',
        meta: {
          title: '任务详情'
        },
        component: () => import('../views/taskInfo/index.vue')
      }, {
        path: '/mine/myPro',
        name: 'myPro',
        meta: {
          title: '我的项目'
        },
        component: () => import('../views/myPro/index.vue')
      }, {
        path: '/taxQuery',
        name: 'TaxQuery',
        meta: {
          title: '个人所得税查询'
        },
        component: () => import('../views/taxQuery/index.vue')
      }, {
        path: '/taxQueryResult',
        name: 'TaxQueryResult',
        meta: {
          title: '个税查询结果'
        },
        component: () => import('../views/taxQuery/result.vue')
      }, {
        path: '/mine/uploadDeliverables',
        name: 'uploadDeliverables',
        meta: {
          title: '上传交付物'
        },
        component: () => import('../views/uploadDeliverables/index.vue')
      }, {
        path: '/mine/settlement',
        name: 'settlement',
        meta: {
          title: '结算记录'
        },
        component: () => import('../views/settlement/index.vue')
      }, {
        path: '/mine/settlementInfo',
        name: 'settlementInfo',
        meta: {
          title: '结算详情'
        },
        component: () => import('../views/settlementInfo/index.vue')
      },       {
        path: '/mine/userInfo',
        name: 'userInfo',
        meta: {
          title: '我的信息'
        },
        component: () => import('../views/userInfo/index.vue')
      },
      {
        path: '/checkIn',
        name: 'CheckIn',
        meta: {
          title: '打卡'
        },
        component: () => import('../views/checkIn/index.vue')
      },
      {
        path: '/mine/about',
        name: 'about',
        meta: {
          title: '关于我们'
        },
        component: () => import('../views/index/index.vue')
      },
      {
        path: '/generatePerson',
        name: 'generatePerson',
        meta: {
          title: '人脸识别'
        },
        component: () => import('../views/face/index.vue')
      },
      {
        path: '/mine/server',
        name: 'server',
        meta: {
          title: '服务协议'
        },
        component: () => import('../views/server/index.vue')
      },
        {
        path: '/mine/privacy',
        name: 'privacy',
        meta: {
          title: '隐私政策'
        },
        component: () => import('../views/privacy/index.vue')
      },
        {
        path: '/mine/tax',
        name: 'tax',
        meta: {
          title: '个税明细'
        },
        component: () => import('../views/tax/index.vue')
      },
      {
        path: '/mine/contract',
        name: 'contract',
        meta: {
          title: '查看合同'
        },
        component: () => import('../views/contract/index.vue')
      },
      {
        path: '/mine/signing',
        name: 'signing',
        meta: {
          title: '签署等待'
        },
        component: () => import('../views/signing/index.vue')
      },
      {
        path: '/mine/contractCallback',
        name: 'contractCallback',
        meta: {
          title: '跳转到合同签署页面'
        },
        component: () => import('../views/contract/callback.vue')
      }
    ]
  }, {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_API,
  routes
})

const getRoot = function (url) {
  const appid = process.env.VUE_APP_BASE_APPID
  // 对URL进行编码，确保查询参数不会丢失
  const encodedUrl = encodeURIComponent(url)
  const redirectURI = encodeURIComponent(`${process.env.VUE_APP_BASE_REDIRECT}/checkRoot?url=${encodedUrl}`)
  const link = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectURI}&response_type=code&scope=snsapi_base#wechat_redirect`
  console.log('重定向到微信授权，原始URL:', url)
  console.log('编码后的URL:', encodedUrl)
  location.href = link
}
const getQueryObject = function (url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

const whiteList = ['/checkRoot'] // 白名单

router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 解决IOS客户端在history模式下签名失败问题
  if (window.entryUrl === undefined) {
    window.entryUrl = document.URL
  }

  // 与keepLive缓存组件冲突暂弃用
  // const u = navigator.userAgent
  // const IsiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // if (IsiOS && to.path !== location.pathname) {
  //   location.assign(to.fullPath)
  // }

  // 跳过授权--本地测试时启用
  localStorage.setItem('MERNO', 'MI460985749859016704')
  sessionStorage.setItem('TOKEN', '6ecf2cc6-fd6a-41cc-9f9b-0f64222fce1e')
  next()

  // 授权相关处理
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    if (to.path === '/mine/userInfo') {
      const urlData = getQueryObject(to.fullPath)
      if (urlData.content) {
        localStorage.setItem('MERNO', urlData.content)
      } else {
        // localStorage.setItem('MERNO', 'MI117371407499763712')
      }
    }

    const token = sessionStorage.getItem('TOKEN')
    if (token) {
      next()
    } else {
      getRoot(to.fullPath)
    }
  }
})

export default router
